import React from 'react';

export default function AutoJournal() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Auto Journal</h1>
      <p className="text-gray-500">Halaman Auto Journal</p>
    </div>
  );
}
